import { Tooltip } from '@mantine/core'
import { IconShoppingBag, IconBuildingStore, IconTool, IconArrowsExchange, IconInbox } from '@tabler/icons-react'

export const preparationTypes = {
    shopify: { label: 'Commande Shopify', filterLabel: 'Shopify', icon: IconShoppingBag },
    retailer: { label: 'Commande revendeur', filterLabel: 'Revendeurs', icon: IconBuildingStore },
    service_case: { label: 'SAV', filterLabel: 'SAV', icon: IconTool },
    transfer: { label: 'Transfert interne', filterLabel: 'Transferts', icon: IconArrowsExchange },
    manual: { label: 'Préparation manuelle', filterLabel: 'Manuelles', icon: IconInbox },
}

export function preparationType(order) {
    // Match the precedence used by the preparation dashboard in the redesign.
    if (order.to_location_id) return 'transfer'
    if (order.service_case_id) return 'service_case'
    if (order.retailer_estimate_id) return 'retailer'
    if (order.order_id) return 'shopify'
    return 'manual'
}

export default function PreparationType({ order }) {
    const { label, icon: Icon } = preparationTypes[preparationType(order)]
    return (
        <Tooltip label={label} withinPortal events={{ hover: true, focus: true, touch: true }}>
            <span tabIndex={0} className="inline-flex shrink-0 rounded text-gray-500 focus-visible:outline-2 focus-visible:outline-baltic">
                <Icon size={18} aria-hidden="true" />
                <span className="sr-only">{label}</span>
            </span>
        </Tooltip>
    )
}
